import { TournamentPhases } from "./types"


export const MAPPED_PHASES: Record<TournamentPhases, number> = {
  [TournamentPhases.UPCOMING]: 0,
  [TournamentPhases.REGISTRATION_STARTED]: 1,
  [TournamentPhases.REGISTRATION_FINISHED]: 2,
  [TournamentPhases.RUNNING]: 3,
  [TournamentPhases.FINISHED]: 4,
};
